/**
 * <pre>
 * ActionTypes factory
 *
 * Summary of responsibilities:
 *
 *  - creates and returns actionTypes.
 * </pre>
 *
 * @author Tim Loram
 * @namespace Factories.ActionTypes
 */

/**
 * Prefix action types with string (usually modules state key) to keep them unique after combine reducers is executed.
 *
 * @property {Object} actionTypes A key value object of action types.
 * @property {String} prefix The prefix to add before all action type values.
 *
 * @return {Object} The prefixed action types object.
 *
 * @memberOf Factories.ActionTypes
 */
function createActionTypes (actionTypes, prefix) {

	for(let actionTypeKey in actionTypes) {
		actionTypes[actionTypeKey] = prefix.toUpperCase()+'_'+actionTypes[actionTypeKey];
	}

	return actionTypes;
}
export default createActionTypes;